module.exports = __webpack_public_path__ + "img/Bulle_Cercle.f828e2c3.png";